import React from 'react';
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom';
import { BreadcrumbProvider } from './context/BreadcrumbContext';
import PrivateRoute from './components/PrivateRoute';
import RestrictedRoute from './components/RestrictedRoute';
import { registrarRotasRestritas } from './util/acessoPermissao';
import { PermissoesProvider } from './context/PermissoesContext';
import ErrorBoundary from './components/ErrorBoundary';
import { isAmbienteTeste } from './util/ambiente';
import Login from './pages/Login';
import LoginEvento from './pages/LoginEvento';
import LoginConfirmarDados from './pages/LoginConfirmarDados';
import LoginRapido from './pages/LoginRapido';
import RecuperarSenha from './pages/RecuperarSenha';
import Registro from './pages/Registro';
import Principal from './pages/Principal';
import Graficos from './pages/Graficos';
import UploadNotaFiscal from './pages/FornecedorPublico/UploadNotaFiscal';
import CadastroFornecedorPublico from './pages/FornecedorPublico/CadastroFornecedor';
import UploadNFRetroativa from './pages/Admin/UploadNFRetroativa';
import PainelAuditLog from './pages/Admin/PainelAuditLog';
import PainelAcesso from './pages/Admin/PainelAcesso';
import AlterarSenha from './pages/AlterarSenha';
import NotFound from './pages/NotFound';
import TestarErroBoundary from './pages/TestarErroBoundary';
import PainelTestesQA from './pages/TestesQA/PainelTestesQA';

import PainelEvento from './pages/Evento/PainelEvento';
import CadastroEvento from './pages/Evento/CadastroEvento';
import TesteObservacao from './pages/Teste/TesteObservacao';
import CadastroEventoPergunta from './pages/Evento/CadastroEventoPergunta';
import CadastroEventoSatisfacaoPergunta from './pages/Evento/CadastroEventoSatisfacaoPergunta';
import ResultadoSatisfacao from './pages/Evento/ResultadoSatisfacao';

import PainelEventoPergunta from './pages/Evento/PainelEventoPergunta';
// import PainelEventoSatisfacaoPergunta from './pages/Evento/PainelEventoSatisfacaoPergunta'; // Removido - agora é modal no PainelEvento

import PainelBriefing from './pages/Briefing/PainelBriefing';
import ListaBriefingCliente from './pages/Briefing/ListaBriefingCliente';
import PainelBriefingCliente from './pages/Briefing/PainelBriefingCliente';
import CadastroModeloBriefing from './pages/Briefing/CadastroModeloBriefing';
import VisualizarBriefing from './pages/Briefing/VisualizarBriefing';
import CadastroBriefingAdvisoryBoard from './pages/Briefing/CadastroBriefingAdvisoryBoard';
import CadastroBriefingEventoTerceiro from './pages/Briefing/CadastroBriefingEventoTerceiro';
import CadastroBriefingOrganizadoSede from './pages/Briefing/CadastroBriefingOrganizadoSede';
import CadastroBriefingOrganizadoForcaVendas from './pages/Briefing/CadastroBriefingOrganizadoForcaVendas';

import PainelRsvp from './pages/Rsvp/PainelRsvp';

import PainelProduto from './pages/Produto/PainelProduto';
import CadastroProduto from './pages/Produto/CadastroProduto';
import PainelProdutoGrupo from './pages/ProdutoGrupo/PainelProdutoGrupo';
import CadastroProdutoGrupo from './pages/ProdutoGrupo/CadastroProdutoGrupo';
import PainelProdutoTipoAtributo from './pages/ProdutoTipoAtributo/PainelProdutoTipoAtributo';
import CadastroProdutoTipoAtributo from './pages/ProdutoTipoAtributo/CadastroProdutoTipoAtributo';
import PainelProdutoAtributo from './pages/ProdutoAtributo/PainelProdutoAtributo';
import CadastroProdutoAtributo from './pages/ProdutoAtributo/CadastroProdutoAtributo';

import PainelProdutoOrcamento from './pages/Produto/PainelProdutoOrcamento';
import CadastroProdutoOrcamento from './pages/Produto/CadastroProdutoOrcamento';

import PainelServicoOrcamento from './pages/Produto/PainelServicoOrcamento';
import CadastroServicoOrcamento from './pages/Produto/CadastroServicoOrcamento';
import ServicoOrcamentoRelatorio from './pages/Produto/ServicoOrcamentoRelatorio';

import PainelRhCargo from './pages/RhCargo/PainelRhCargo';
import CadastroRhCargo from './pages/RhCargo/CadastroRhCargo';

import PainelCliente from './pages/Cliente/PainelCliente';
import CadastroCliente from './pages/Cliente/CadastroCliente';
import PainelLocal from './pages/Local/PainelLocal';
import CadastroLocal from './pages/Local/CadastroLocal';
import PainelFornecedor from './pages/Fornecedor/PainelFornecedor';
import PainelDisparoFornecedor from './pages/Fornecedor/PainelDisparoFornecedor';
import PainelSubmissaoFornecedor from './pages/Fornecedor/PainelSubmissaoFornecedor';
import CadastroFornecedor from './pages/Fornecedor/CadastroFornecedor';
import PainelFornecedorGrupo from './pages/FornecedorGrupo/PainelFornecedorGrupo';
import CadastroFornecedorGrupo from './pages/FornecedorGrupo/CadastroFornecedorGrupo';
import PainelHotel from './pages/Hotel/PainelHotel';
import CadastroHotel from './pages/Hotel/CadastroHotel';
import PainelFreelancer from './pages/Freelancer/PainelFreelancer';
import CadastroFreelancer from './pages/Freelancer/CadastroFreelancer';
import PainelEmpresa from './pages/Empresa/PainelEmpresa';
import CadastroEmpresa from './pages/Empresa/CadastroEmpresa';
import PainelSla from './pages/Sla/PainelSla';
import CadastroSla from './pages/Sla/CadastroSla';
import PainelSlaCriterio from './pages/Sla/PainelSlaCriterio';
import PainelSlaDashboard from './pages/Sla/PainelSlaDashboard';
import CadastroSlaCriterio from './pages/Sla/CadastroSlaCriterio';
import PainelPessoa from './pages/Pessoa/PainelPessoa';
import CadastroPessoa from './pages/Pessoa/CadastroPessoa';
import PainelVenda from './pages/Venda/PainelVenda';
import CadastroVenda from './pages/Venda/CadastroVenda';
import PainelOrcamento from './pages/Orcamento/PainelOrcamento';
import CadastroOrcamento from './pages/Orcamento/CadastroOrcamento';
import CadastroPagamentoOrcamento from './pages/Orcamento/CadastroPagamentoOrcamento';
import ResumoOrcamento from './pages/Orcamento/ResumoOrcamento';
import SolicitarAdiantamento from './pages/Orcamento/SolicitarAdiantamento';
import EnviarParaFinanceiro from './pages/Orcamento/EnviarParaFinanceiro';
import PainelCompra from './pages/Compra/PainelCompra';
import CadastroCompra from './pages/Compra/CadastroCompra';
import SolicitarGasto from './pages/Compra/SolicitarGasto';
import PainelEventoChecklistAtividade from './pages/Evento/ChecklistModelo/Atividade/PainelEventoChecklistAtividade';
import CadastroEventoChecklistAtividade from './pages/Evento/ChecklistModelo/Atividade/CadastroEventoChecklistAtividade';
import PainelFinanceiro from './pages/Financeiro/PainelFinanceiro';
import PainelRaioXFinanceiro from './pages/Financeiro/RaioX/PainelRaioXFinanceiro';
import PainelNotaFiscal from './pages/NotaFiscal/PainelNotaFiscal';
import CadastroNotaFiscal from './pages/NotaFiscal/CadastroNotaFiscal';
import PainelParcelaPagar from './pages/Financeiro/Parcela/Pagar/PainelParcelaPagar';
import PainelSaldoAdiantamento from './pages/Financeiro/Adiantamento/PainelSaldoAdiantamento';
import DetalheAdiantamento from './pages/Financeiro/Adiantamento/DetalheAdiantamento';
import PainelFaturamento from './pages/Financeiro/Faturamento/PainelFaturamento';
import DetalheFaturamento from './pages/Financeiro/Faturamento/DetalheFaturamento';
import PreEnvioFaturamento from './pages/Financeiro/Faturamento/PreEnvioFaturamento';
import DetalheParcelaPagar from './pages/Financeiro/Parcela/Pagar/DetalheParcelaPagar';
import DetalhePrevisaoPagamento from './pages/Financeiro/Parcela/Pagar/DetalhePrevisaoPagamento';
import PagamentoCartao from './pages/Financeiro/Parcela/Pagar/PagamentoCartao';
import CadastroParcelaPagar from './pages/Financeiro/Parcela/Pagar/CadastroParcelaPagar';
import PainelParcelaReceber from './pages/Financeiro/Parcela/Receber/PainelParcelaReceber';
import CadastroParcelaReceber from './pages/Financeiro/Parcela/Receber/CadastroParcelaReceber';
import PainelParcelaPeriodica from './pages/Financeiro/Parcela/Periodica/PainelParcelaPeriodica';
import CadastroParcelaPeriodica from './pages/Financeiro/Parcela/Periodica/CadastroParcelaPeriodica';
import PainelPlanoConta from './pages/Financeiro/PlanoConta/PainelPlanoConta';
import CadastroPlanoConta from './pages/Financeiro/PlanoConta/CadastroPlanoConta';
import PainelCaixa from './pages/Financeiro/Caixa/PainelCaixa';
import CadastroCaixa from './pages/Financeiro/Caixa/CadastroCaixa';
import RelatorioCompraVenda from './pages/Venda/RelatorioCompraVenda';
import RelatorioCompra from './pages/Venda/RelatorioCompra';
import RelatorioFinanceiroParcela from './pages/Financeiro/Parcela/RelatorioFinanceiroParcela';
import PainelParticipanteCategoria from './pages/ParticipanteCategoria/PainelParticipanteCategoria';
import CadastroParticipanteCategoria from './pages/ParticipanteCategoria/CadastroParticipanteCategoria';
import AlterarContaFornecedor from './pages/Financeiro/Parcela/AlterarContaFornecedor';
import CadastroEventoDiaQuantidade from './pages/Evento/CadastroEventoDiaQuantidade';
import CadastroEventoAgenda from './pages/Evento/CadastroEventoAgenda';
import eventoImportarOpcaoAereo from './pages/Evento/EventoImportarOpcaoAereo';
import EventoImportarKpi from './pages/Evento/EventoImportarKpi';
import EventoImportarParticipante from './pages/Evento/EventoImportarParticipante';
import EventoImportarPerguntasSatisfacao from './pages/Evento/EventoImportarPerguntasSatisfacao';
import EventoImportarAereo from './pages/Evento/EventoImportarAereo';
import EventoImportarHospedagem from './pages/Evento/EventoImportarHospedagem';
import EventoImportarInscricoes from './pages/Evento/EventoImportarInscricoes';
import EventoImportarCartas from './pages/Evento/EventoImportarCartas';
import EventoImportarEventos from './pages/Evento/EventoImportarEventos';
import EventoImportarSanofi from './pages/Evento/EventoImportarSanofi';
import PainelEventoCarta from './pages/Evento/Carta/PainelEventoCarta';
import PainelEventoChecklistModelo from './pages/Evento/ChecklistModelo/PainelEventoChecklistModelo';
import PainelProdutoBu from './pages/ProdutoBu/PainelProdutoBu';
import PainelProdutoUnidadeNegocio from './pages/ProdutoUnidadeNegocio/PainelProdutoUnidadeNegocio';
import PainelProdutoLinha from './pages/ProdutoLinha/PainelProdutoLinha';
import CadastroProdutoBu from './pages/ProdutoBu/CadastroProdutoBu';
import CadastroProdutoUnidadeNegocio from './pages/ProdutoUnidadeNegocio/CadastroProdutoUnidadeNegocio';
import CadastroProdutoLinha from './pages/ProdutoLinha/CadastroProdutoLinha';
import PainelEventoResponsavelCliente from './pages/Evento/PainelEventoResponsavelCliente';
import CadastroEventoResponsavelCliente from './pages/Evento/CadastroEventoResponsavelCliente';
import PainelEventoHistorico from './pages/Evento/PainelEventoHistorico';
import RelatorioDre from './pages/Financeiro/RelatorioDre';
import CadastroEventoPerguntaQrCode from './pages/Evento/CadastroEventoPerguntaQrCode';
import CadastroEventoRsvp from './pages/Evento/CadastroEventoRsvp';
import CadastroEventoRsvpDadosIniciais from './pages/Evento/CadastroEventoRsvpDadosIniciais';
import LiberarStartRsvp from './pages/Evento/LiberarStartRsvp';
import CadastroEventoRsvpOpcaoAereo from './pages/Evento/CadastroEventoRsvpOpcaoAereo';
import CadastroEventoSolicitacaoAereo from './pages/Evento/CadastroEventoSolicitacaoAereo';
import CadastroEventoSolicitacoesAereo from './pages/Evento/CadastroEventoSolicitacoesAereo';
import CadastroEventoMalhasAereo from './pages/Evento/CadastroEventoMalhasAereo';
import CadastroEventoPortacaoAereo from './pages/Evento/CadastroEventoPortacaoAereo';
import CadastroEventoEmissaoEnvioAereo from './pages/Evento/CadastroEventoEmissaoEnvioAereo';
import CadastroEventoEmissaoAereo from './pages/Evento/CadastroEventoEmissaoAereo';
import AereoFaturaCvc from './pages/Evento/AereoFaturaCvc';
import CadastroEventoImportarMalhaAereo from './pages/Evento/CadastroEventoImportarMalhaAereo';
import CadastroEventoSugestaoAereo from './pages/Evento/CadastroEventoSugestaoAereo';
import PainelAereo from './pages/Evento/PainelAereo';
import RascunhoMalhaAereo from './pages/Evento/RascunhoMalhaAereo';
import PainelBackoffice from './pages/Evento/PainelBackoffice';

import PainelEventoPalestrante from './pages/Evento/Palestrante/PainelEventoPalestrante';
import CadastroEventoPalestrante from './pages/Evento/Palestrante/CadastroEventoPalestrante';

import PainelEventoParticipante from './pages/Evento/Participante/PainelEventoParticipante';
import PainelCartaFila from './pages/Evento/Carta/PainelCartaFila';
import { PERFIS_FILA, PERFIS_ENVIO_MASSA } from './components/CartaFilaStatus';
import CadastroEventoParticipante from './pages/Evento/Participante/CadastroEventoParticipante';
import CadastroEventoParticipanteAssinatura from './pages/Evento/Participante/CadastroEventoParticipanteAssinatura';
import CadastroEventoParticipanteConvite from './pages/Evento/Participante/CadastroEventoParticipanteConvite';
import CadastroEventoParticipanteAereoConvite from './pages/Evento/Participante/CadastroEventoParticipanteAereoConvite';
import CadastroEventoParticipanteTransferConvite from './pages/Evento/Participante/CadastroEventoParticipanteTransferConvite';
import CadastroEventoParticipanteHotelConvite from './pages/Evento/Participante/CadastroEventoParticipanteHotelConvite';
import CadastroEventoParticipanteLista from './pages/Evento/Participante/CadastroEventoParticipanteLista';
import CadastroEventoParticipanteListaConcluido from './pages/Evento/Participante/CadastroEventoParticipanteListaConcluido';
import CadastroEventoParticipanteConviteConcluido from './pages/Evento/Participante/CadastroEventoParticipanteConviteConcluido';
import CadastroEventoParticipanteConviteRecusado from './pages/Evento/Participante/CadastroEventoParticipanteConviteRecusado';
import RelatorioListaPresenca from './pages/Rsvp/RelatorioListaPresenca';
import CadastroEventoParticipanteOperador from './pages/Evento/Participante/CadastroEventoParticipanteOperador';
import PainelEventoParticipanteSituacao from './pages/Evento/Participante/Situacao/PainelEventoParticipanteSituacao';
import CadastroEventoParticipanteSituacao from './pages/Evento/Participante/Situacao/CadastroEventoParticipanteSituacao';
import EventoVincularParticipanteOperador from './pages/Evento/Participante/EventoVincularParticipanteOperador';
import CadastroEventoCarta from './pages/Evento/Carta/CadastroEventoCarta';
import CadastroEventoChecklistModelo from './pages/Evento/ChecklistModelo/CadastroEventoChecklistModelo';
import CadastroEventoChecklist from './pages/Evento/Checklist/CadastroEventoChecklist';
import EventoRelatorioParticipante from './pages/Evento/EventoRelatorioParticipante';
import RelatorioPagamentoOrcamento from './pages/Orcamento/RelatorioPagamentoOrcamento';
import ExportarEventoExecucao from './pages/Evento/Bi/ExportarEventoExecucao';
import OnePageEvento from './pages/Evento/OnePageEvento';
import ResumoBackOffice from './pages/Evento/ResumoBackOffice';
import ResumoRsvp from './pages/Evento/ResumoRsvp';
import ResumoBook from './pages/Evento/ResumoBook';
import ImportarOrcamento from './pages/Orcamento/ImportarOrcamento';
import PainelChecklist from './pages/Evento/Checklist/PainelChecklist';
import CadastroEventoParticipanteAceitarTermo from './pages/Evento/Participante/CadastroEventoParticipanteAceitarTermo';
import CadastroEventoParticipanteAceitarConvite from './pages/Evento/Participante/CadastroEventoParticipanteAceitarConvite';
import CadastroEventoParticipanteCartaInformativa from './pages/Evento/Participante/CadastroEventoParticipanteCartaInformativa';
import CadastroEventoParticipanteContratoEnviado from './pages/Evento/Participante/CadastroEventoParticipanteContratoEnviado';
import EventoRelatorio from './pages/Evento/EventoRelatorio';
import PainelEventoOrdemServico from './pages/Evento/PainelEventoOrdemServico';
import CadastroEventoOrdemServico from './pages/Evento/CadastroEventoOrdemServico';
import CadastroEventoOrdemServicoResumo from './pages/Evento/CadastroEventoOrdemServicoResumo';
import AlterarEventoChecklist from './pages/Evento/Checklist/AlterarEventoChecklist';
import PainelChecklistItens from './pages/Evento/Checklist/PainelChecklistItens';
import PainelOrcamentoModelo from './pages/OrcamentoModelo/PainelOrcamentoModelo';
import CadastroOrcamentoModelo from './pages/OrcamentoModelo/CadastroOrcamentoModelo';
import ConfiguracaoOrcamentoModelo from './pages/OrcamentoModelo/ConfiguracaoOrcamentoModelo';

// Boundary único no layout: captura erros de renderização de QUALQUER tela,
// loga (incluindo a rota/pathname) e exibe um fallback amigável. O `pathname`
// permite resetar o estado ao navegar para outra tela.
function LayoutErrorBoundary({ children }) {
    const location = useLocation();
    return <ErrorBoundary pathname={location.pathname}>{children}</ErrorBoundary>;
}

// As telas restritas: além das regras da PrivateRoute, só abrem para quem tem uma regra que as abra (Permissões de
// Acesso; o admin abre todas). As rotas de cada regra estão no banco (`permissao.rotas`); os menus e os botões
// conferem pelo mesmo registro. O `nome` e o `grupo` são os da lista das regras: o grupo junta no mesmo acordeão as
// telas e os endpoints da API do grupo `restrito:<grupo>` de mesmo nome.
const GRUPO_AEREO = 'Fluxo de Aéreo';
const ROTAS_RESTRITAS = React.Children.toArray([
  <RestrictedRoute path="/cadastroEventoSolicitacoesAereo/:idEvento?" grupo={GRUPO_AEREO} nome="Solicitações de Malha Aérea" component={CadastroEventoSolicitacoesAereo} />,
  <RestrictedRoute path="/cadastroEventoSolicitacaoAereo/:idSolicitacao?" grupo={GRUPO_AEREO} nome="Solicitação de Malha Aérea" component={CadastroEventoSolicitacaoAereo} />,
  <RestrictedRoute path="/cadastroEventoMalhasAereo/:idSolicitacao?" grupo={GRUPO_AEREO} nome="Malhas da Solicitação" component={CadastroEventoMalhasAereo} />,
  <RestrictedRoute path="/cadastroEventoPortacaoAereo/:idEvento?" grupo={GRUPO_AEREO} nome="Importação das Opções de Aéreo" component={CadastroEventoPortacaoAereo} />,
  <RestrictedRoute path="/cadastroEventoEmissaoEnvioAereo/:idEvento?" grupo={GRUPO_AEREO} nome="Solicitar Emissão de Aéreo" component={CadastroEventoEmissaoEnvioAereo} />,
  <RestrictedRoute path="/cadastroEventoImportarMalhaAereo/:idMalha?" grupo={GRUPO_AEREO} nome="Importação Malha Aérea" component={CadastroEventoImportarMalhaAereo} />,
  <RestrictedRoute path="/cadastroEventoSugestaoAereo/:idEvento?" grupo={GRUPO_AEREO} nome="Sugestão de Voos" component={CadastroEventoSugestaoAereo} />,
]);
registrarRotasRestritas(ROTAS_RESTRITAS.map(el => ({ rota: el.props.path.split('/:')[0], nome: el.props.nome, grupo: el.props.grupo })));

const PERFIS_USUARIOS = ['rh', 'admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'gerentersvp', 'gerenteevento', 'gerenteeventointernacional', 'coordenadorrsvp'];

export default function Routes() {
  const ambienteTeste = isAmbienteTeste();


  return (
    <BrowserRouter>
      <BreadcrumbProvider>
      <PermissoesProvider>
      <LayoutErrorBoundary>
      <Switch>
        {/* Rota pública - Upload de NF pelo fornecedor */}
        <Route path="/fornecedor/upload-nf/:token" exact component={UploadNotaFiscal} />
        {/* Rota pública - formulário de cadastro preenchido pelo fornecedor */}
        <Route path="/fornecedor/cadastro/:token" exact component={CadastroFornecedorPublico} />

        {/* QA: validacao do ErrorBoundary — gated para o ambiente de teste (sandbox), "nao encontrado" fora dele */}
        {
          ambienteTeste &&
          <PrivateRoute path="/testarErroBoundary" component={TestarErroBoundary} />
        }
        {/* QA: página de teste do ObservacaoAnexos, só no ambiente de teste (sandbox) */}
        {
          ambienteTeste &&
          <PrivateRoute path="/testeObservacao" component={TesteObservacao} />
        }
        <Route path="/" exact component={localStorage.getItem("token") ? Principal : Login} />
        <Route path="/login" exact component={Login} />
        <Route path="/recuperar-senha" exact component={RecuperarSenha} />
        <Route path="/loginEvento/:id?" exact component={LoginEvento} />
        <Route path="/loginConfirmarDados/:id?" exact component={LoginConfirmarDados} />
        <Route path="/loginRapido/:id/:rota" exact component={LoginRapido} />
        
        {/* Rota admin - Upload de NF Retroativa */}
        <PrivateRoute path="/admin/upload-nf-retroativa" exact component={UploadNFRetroativa} />
        <PrivateRoute path="/auditLog" exact component={PainelAuditLog} roles={['admin']} />
        <PrivateRoute path="/acesso" exact component={PainelAcesso} roles={['admin']} />
        <Route path="/registro" component={Registro} />

        <PrivateRoute path="/graficos" component={Graficos} />
        <PrivateRoute path="/principal" component={Principal} />
        {/* QA: painel de testes — só fora do dashboard (produção), como a /testarErroBoundary.
            Sem `roles` de propósito: o menu esconde de quem não usa, mas a rota fica aberta a
            qualquer usuário logado — travar aqui sem saber o perfil de cada testador tiraria o
            acesso de quem precisa marcar teste. Feche quando os perfis dos testadores estiverem
            confirmados. */}
        {
          ambienteTeste &&
          <PrivateRoute path="/qaTestes" component={PainelTestesQA} />
        }

        <PrivateRoute path="/financeiro/alterarContaFornecedor" component={AlterarContaFornecedor} />
        <PrivateRoute exact path="/financeiro/parcela-periodica/nova" component={CadastroParcelaPeriodica} />
        <PrivateRoute exact path="/financeiro/parcela-periodica/editar/:id" component={CadastroParcelaPeriodica} />
        <PrivateRoute exact path="/financeiro/parcela-periodica" component={PainelParcelaPeriodica} />
        <PrivateRoute path="/financeiro" component={PainelFinanceiro} />

        {/* Notas Fiscais — Épico 3 Financeiro */}
        <PrivateRoute exact path="/notaFiscal" component={PainelNotaFiscal} />
        <PrivateRoute path="/cadastroNotaFiscal/:id?" component={CadastroNotaFiscal} />

        <PrivateRoute path="/briefing" component={PainelBriefing} />
        <PrivateRoute path="/listaBriefingCliente" component={ListaBriefingCliente} />
        <PrivateRoute path="/briefingCliente" component={PainelBriefingCliente} />
        <PrivateRoute path="/cadastroModeloBriefing" component={CadastroModeloBriefing} />
        <PrivateRoute path="/visualizarBriefing/:id?" component={VisualizarBriefing} />
        <PrivateRoute path="/cadastroBriefingAdvisoryBoard/:id?" component={CadastroBriefingAdvisoryBoard} />
        <PrivateRoute path="/cadastroBriefingEventoTerceiro/:id?" component={CadastroBriefingEventoTerceiro} />
        <PrivateRoute path="/cadastroBriefingOrganizadoSede/:id?" component={CadastroBriefingOrganizadoSede} />
        <PrivateRoute path="/cadastroBriefingOrganizadoForcaVendas/:id?" component={CadastroBriefingOrganizadoForcaVendas} />

        <PrivateRoute path="/eventoPergunta" component={PainelEventoPergunta} />
        <PrivateRoute path="/eventoPerguntaQrCode/:id?" component={CadastroEventoPerguntaQrCode} />

        {/* <PrivateRoute path="/eventoSatisfacaoPergunta" component={PainelEventoSatisfacaoPergunta} /> */}
        <PrivateRoute path="/cadastroEventoSatisfacaoPergunta/:id?" component={CadastroEventoSatisfacaoPergunta} />
        <PrivateRoute path="/eventoSatisfacaoResultado/:id" component={ResultadoSatisfacao} />

        <PrivateRoute path="/eventoOrdemServico" component={PainelEventoOrdemServico} />
        <PrivateRoute path="/cadastroEventoOrdemServico/:idEvento?" component={CadastroEventoOrdemServico} />

        <PrivateRoute path="/evento" component={PainelEvento} />
        <PrivateRoute path="/eventoLiberarStartRsvp" component={LiberarStartRsvp} />
        <PrivateRoute path="/cadastroEvento/:id?" component={CadastroEvento} />
        <PrivateRoute path="/cadastroEventoPergunta/:id?" component={CadastroEventoPergunta} />
        <PrivateRoute path="/cadastroEventoRsvp/:id?" component={CadastroEventoRsvp} />
        <PrivateRoute path="/eventoDadosIniciaisRsvp/:id?" component={CadastroEventoRsvpDadosIniciais} roles={['admin', 'diretor', 'gerentersvp', 'coordenadorrsvp', 'gerenteevento', 'gerenteeventointernacional', 'evento']}/>
        <PrivateRoute path="/cadastroEventoRsvpOpcaoAereo/:id?" component={CadastroEventoRsvpOpcaoAereo} />
        {ROTAS_RESTRITAS}
        <PrivateRoute path="/cadastroEventoEmissaoAereo/:idEvento?" component={CadastroEventoEmissaoAereo} />
        <PrivateRoute path="/aereoFaturaCvc" component={AereoFaturaCvc} roles={['admin', 'aereo', 'gerenteaereo']} />
        <PrivateRoute path="/aereo" component={PainelAereo} roles={['admin', 'aereo', 'gerenteaereo']} />
        <PrivateRoute path="/rascunhoMalhaAereo" component={RascunhoMalhaAereo} roles={['admin', 'aereo', 'gerenteaereo']} />
        {/* O painel da demanda do Backoffice: o status de cada evento, como o /aereo é o do Aéreo. */}
        <PrivateRoute path="/backoffice" component={PainelBackoffice} roles={['admin', 'backoffice']} />
        <PrivateRoute path="/cadastroEventoDiaQuantidade/:id?" component={CadastroEventoDiaQuantidade} />
        <PrivateRoute path="/cadastroEventoAgenda/:id?" component={CadastroEventoAgenda} />
        <PrivateRoute path="/eventoImportarOpcaoAereo/:id?" component={eventoImportarOpcaoAereo} />
        <PrivateRoute path="/eventoImportarKpi" component={EventoImportarKpi} />
        <PrivateRoute path="/eventoImportarEventos" component={EventoImportarEventos} />
        <PrivateRoute path="/eventoImportarSanofi" component={EventoImportarSanofi} />
        <PrivateRoute path="/eventoImportarParticipante/:id?" component={EventoImportarParticipante} />
        <PrivateRoute path="/eventoImportarPerguntasSatisfacao/:id?" component={EventoImportarPerguntasSatisfacao} />
        <PrivateRoute path="/eventoRelatorioParticipante/:id?" component={EventoRelatorioParticipante} />
        <PrivateRoute path="/eventoImportarAereo/:id?" component={EventoImportarAereo} />
        <PrivateRoute path="/eventoImportarHospedagem/:id?" component={EventoImportarHospedagem} />
        <PrivateRoute path="/eventoImportarInscricoes/:id?" component={EventoImportarInscricoes} />
        <PrivateRoute path="/eventoImportarCartas/:id?" component={EventoImportarCartas} />
        <PrivateRoute path="/eventoResponsavelCliente" component={PainelEventoResponsavelCliente} />
        <PrivateRoute path="/eventoParticipanteSituacao" component={PainelEventoParticipanteSituacao} />
        <PrivateRoute path="/cadastroEventoParticipanteSituacao/:id?" component={CadastroEventoParticipanteSituacao} />
        <PrivateRoute path="/cadastroEventoResponsavelCliente/:id?" component={CadastroEventoResponsavelCliente} />
        <PrivateRoute path="/eventoHistorico/:id?" component={PainelEventoHistorico} />

        <PrivateRoute path="/eventoPalestrante/:id?" component={PainelEventoPalestrante} />
        <PrivateRoute path="/cadastroEventoPalestrante/:id?" component={CadastroEventoPalestrante} />

        {/* Mesmos perfis que enviam carta (perfisCarta do PainelEventoParticipante). Sem
            allowlist a rota caía no `return true` do PrivateRoute, e a tela expõe a coluna
            Erro, que carrega mensagem crua de SMTP e de banco. */}
        <PrivateRoute path="/cartaFila/:id" component={PainelCartaFila} roles={PERFIS_FILA} />
        {/* A mesma tela sem evento: a fila de todos os eventos, so para quem dispara em massa.
            `exact` para a rota nunca engolir a /cartaFila/:id, qualquer que seja a ordem. */}
        <PrivateRoute exact path="/cartaFila" component={PainelCartaFila} roles={PERFIS_ENVIO_MASSA} />
        <PrivateRoute path="/eventoParticipante/:id?" component={PainelEventoParticipante} />
        <PrivateRoute path="/cadastroEventoOrdemServicoResumo/:id?" component={CadastroEventoOrdemServicoResumo} />
        <PrivateRoute path="/relatorioListaPresenca/:idEvento?" component={RelatorioListaPresenca} />
        <PrivateRoute path="/eventoVincularParticipanteOperador/:id?" component={EventoVincularParticipanteOperador} />
        <PrivateRoute path="/cadastroEventoParticipante/:id?" component={CadastroEventoParticipante} />
        <PrivateRoute path="/cadastroEventoParticipanteAssinatura/:id?" component={CadastroEventoParticipanteAssinatura} />
        <PrivateRoute path="/cadastroEventoParticipanteAceitarTermo/:id?" component={CadastroEventoParticipanteAceitarTermo} />
        <PrivateRoute path="/cadastroEventoParticipanteAceitarConvite/:id?" component={CadastroEventoParticipanteAceitarConvite} />
        <PrivateRoute path="/cadastroEventoParticipanteCartaInformativa/:id?" component={CadastroEventoParticipanteCartaInformativa} />
        <PrivateRoute path="/cadastroEventoParticipanteConvite/:id?" component={CadastroEventoParticipanteConvite} />
        <PrivateRoute path="/cadastroEventoParticipanteAereoConvite/:id?" component={CadastroEventoParticipanteAereoConvite} />
        <PrivateRoute path="/cadastroEventoParticipanteTransferConvite/:id?" component={CadastroEventoParticipanteTransferConvite} />
        <PrivateRoute path="/cadastroEventoParticipanteHotelConvite/:id?" component={CadastroEventoParticipanteHotelConvite} />
        <PrivateRoute path="/cadastroEventoParticipanteLista/:id?" component={CadastroEventoParticipanteLista} />
        <PrivateRoute path="/cadastroEventoParticipanteListaConcluido/:id?" component={CadastroEventoParticipanteListaConcluido} />
        <Route path="/cadastroEventoParticipanteConviteConcluido/:id?" component={CadastroEventoParticipanteConviteConcluido} />
        <PrivateRoute path="/cadastroEventoParticipanteContratoEnviado/:id?" component={CadastroEventoParticipanteContratoEnviado} />
        <PrivateRoute path="/cadastroEventoParticipanteConviteRecusado/:id?" component={CadastroEventoParticipanteConviteRecusado} />
        <PrivateRoute path="/cadastroEventoParticipanteOperador" component={CadastroEventoParticipanteOperador} />
        <PrivateRoute path="/exportarEventoExecucao" component={ExportarEventoExecucao} />
        <PrivateRoute path="/onePageEvento/:id" component={OnePageEvento} />
        <PrivateRoute path="/eventoResumoBackOffice/:id" component={ResumoBackOffice} />
        <PrivateRoute path="/eventoResumoRsvp/:id" component={ResumoRsvp} />
        <PrivateRoute path="/eventoResumoBook/:id" component={ResumoBook} />
        <PrivateRoute path="/eventoRelatorio" component={EventoRelatorio} />


        <PrivateRoute path="/eventoCarta" component={PainelEventoCarta} />
        <PrivateRoute path="/cadastroEventoCarta/:id?" component={CadastroEventoCarta} />

        <PrivateRoute path="/checklist" component={PainelChecklist} />
        <PrivateRoute path="/checklistItens" component={PainelChecklistItens} />
        <PrivateRoute path="/eventoChecklistModelo" component={PainelEventoChecklistModelo} />
        <PrivateRoute path="/cadastroEventoChecklistModelo/:id?" component={CadastroEventoChecklistModelo} />
        <PrivateRoute path="/cadastroEventoChecklist" component={CadastroEventoChecklist} />
        <PrivateRoute path="/alterarEventoChecklist/:id?" component={AlterarEventoChecklist} />

        <PrivateRoute path="/rsvp" component={PainelRsvp} />

        <PrivateRoute path="/produto" component={PainelProduto} />
        <PrivateRoute path="/cadastroProduto/:id?" component={CadastroProduto} />
        <PrivateRoute path="/produtoGrupo" component={PainelProdutoGrupo} />
        <PrivateRoute path="/produtoBu" component={PainelProdutoBu} />
        <PrivateRoute path="/produtoUnidadeNegocio" component={PainelProdutoUnidadeNegocio} />
        <PrivateRoute path="/produtoLinha" component={PainelProdutoLinha} />
        <PrivateRoute path="/cadastroProdutoGrupo/:id?" component={CadastroProdutoGrupo} />
        <PrivateRoute path="/cadastroProdutoBu/:id?" component={CadastroProdutoBu} />
        <PrivateRoute path="/cadastroProdutoUnidadeNegocio/:id?" component={CadastroProdutoUnidadeNegocio} />
        <PrivateRoute path="/cadastroProdutoLinha/:id?" component={CadastroProdutoLinha} />
        <PrivateRoute path="/produtoTipoAtributo" component={PainelProdutoTipoAtributo} />
        <PrivateRoute path="/cadastroProdutoTipoAtributo/:id?" component={CadastroProdutoTipoAtributo} />
        <PrivateRoute path="/produtoAtributo" component={PainelProdutoAtributo} />
        <PrivateRoute path="/cadastroProdutoAtributo/:id?" component={CadastroProdutoAtributo} />

        <PrivateRoute path="/produtoOrcamento" component={PainelProdutoOrcamento} />
        <PrivateRoute path="/cadastroProdutoOrcamento/:id?" component={CadastroProdutoOrcamento} />

        <PrivateRoute path="/servicoOrcamento" component={PainelServicoOrcamento} />
        <PrivateRoute path="/cadastroServicoOrcamento/:id?" component={CadastroServicoOrcamento} />
        <PrivateRoute path="/servicoOrcamentoRelatorio" component={ServicoOrcamentoRelatorio} />

        <PrivateRoute path="/rhCargo" component={PainelRhCargo} />
        <PrivateRoute path="/cadastroRhCargo/:id?" component={CadastroRhCargo} />

        <PrivateRoute path="/cliente" component={PainelCliente} />
        <PrivateRoute path="/cadastroCliente/:id?" component={CadastroCliente} />

        <PrivateRoute path="/local" component={PainelLocal} />
        <PrivateRoute path="/cadastroLocal/:id?" component={CadastroLocal} />

        <PrivateRoute exact path="/fornecedorGrupo" component={PainelFornecedorGrupo} />
        <PrivateRoute path="/cadastroFornecedorGrupo/:id?" component={CadastroFornecedorGrupo} />
        <PrivateRoute exact path="/Fornecedor" component={PainelFornecedor} />
        <PrivateRoute path="/cadastroFornecedor/:id?" component={CadastroFornecedor} />
        {/* Allowlist de perfil nas duas: esconder o link não protege quem chega pela
            URL (histórico do navegador, link colado). Disparo manda e-mail real e
            irreversível; a revisão grava agência, conta e PIX vindos de link público
            no cadastro do fornecedor — as duas pesam mais que excluir um cadastro,
            que já era restrito a esta mesma lista. */}
        <PrivateRoute exact path="/fornecedorDisparo" roles={['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'suplier']} component={PainelDisparoFornecedor} />
        <PrivateRoute exact path="/fornecedorSubmissao" roles={['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'suplier']} component={PainelSubmissaoFornecedor} />
        <PrivateRoute exact path="/freelancer" component={PainelFreelancer} />
        <PrivateRoute path="/cadastroFreelancer/:id?" component={CadastroFreelancer} />

        <PrivateRoute path="/hotel" component={PainelHotel} />
        <PrivateRoute path="/cadastroHotel/:id?" component={CadastroHotel} />

        <PrivateRoute path="/participanteCategoria" component={PainelParticipanteCategoria} />
        <PrivateRoute path="/cadastroParticipanteCategoria/:id?" component={CadastroParticipanteCategoria} />

        <PrivateRoute path="/pessoa" roles={PERFIS_USUARIOS} component={PainelPessoa} />
        <PrivateRoute path="/cadastroPessoa/:id?" roles={PERFIS_USUARIOS} component={CadastroPessoa} />



        <PrivateRoute path="/venda" component={PainelVenda} />
        <PrivateRoute path="/cadastroVenda/:id?" component={CadastroVenda} />
        <PrivateRoute path="/relatorioCompraVenda" component={RelatorioCompraVenda} />
        <PrivateRoute path="/relatorioCompra" component={RelatorioCompra} />

        <PrivateRoute path="/orcamento" component={PainelOrcamento} />
        <PrivateRoute path="/solicitarAdiantamento/:id" component={SolicitarAdiantamento} />
        <PrivateRoute path="/enviarParaFinanceiro/:id" component={EnviarParaFinanceiro} />
        {/* Pré-envio do faturamento — a conferência do OPERADOR DE EVENTO antes de
            mandar o orçamento para a fila da Simone. Fica aqui, junto das demais
            rotas de orçamento, e NÃO com prefixo /financeiro: quem abre é Eventos,
            não o Financeiro (as telas dele são /financeiroFaturamento*). */}
        <PrivateRoute path="/faturamentoEnvio/:orcamentoId" exact component={PreEnvioFaturamento} />
        <PrivateRoute path="/cadastroOrcamento/:id?" component={CadastroOrcamento} />
        <PrivateRoute path="/resumoOrcamento/:id" component={ResumoOrcamento} />
        <PrivateRoute path="/importarOrcamento/:id?" component={ImportarOrcamento} />
        <PrivateRoute path="/cadastroPagamentoOrcamento/:id?" component={CadastroPagamentoOrcamento} />
        <PrivateRoute path="/orcamentoRelatorioPagamento" component={RelatorioPagamentoOrcamento} />
        <PrivateRoute path="/orcamentoModelo" component={PainelOrcamentoModelo} />
        <PrivateRoute path="/cadastroOrcamentoModelo/:id?" component={CadastroOrcamentoModelo} />
        <PrivateRoute path="/configuracaoOrcamentoModelo" component={ConfiguracaoOrcamentoModelo} />

        <PrivateRoute path="/compra" component={PainelCompra} />
        <PrivateRoute path="/cadastroCompra/:id?" component={CadastroCompra} />
        <PrivateRoute path="/solicitarGasto" component={SolicitarGasto} />

        {/* Faturamento — etapa entre o fim do evento e o Contas a Receber.
            Fica aqui, no bloco dos demais /financeiro*, e não junto do
            <PrivateRoute path="/financeiro"> não-exact lá de cima: o matcher do
            react-router v5 exige `/` ou fim de string depois do path, então
            "/financeiro" NÃO captura "/financeiroFaturamento" — mesmo motivo
            pelo qual /financeiroParcelaPagar já funciona declarado aqui embaixo. */}
        <PrivateRoute path="/financeiroFaturamento" exact component={PainelFaturamento} />
        <PrivateRoute path="/financeiroFaturamento/:orcamentoId" exact component={DetalheFaturamento} />

        <PrivateRoute path="/financeiroSaldoAdiantamento" component={PainelSaldoAdiantamento} />
        <PrivateRoute path="/financeiroAdiantamentoDetalhe/:id" component={DetalheAdiantamento} />
        {/* Raio-X financeiro do evento / consolidado do cliente (treinamento 07/10, item 14) */}
        <PrivateRoute path="/financeiroRaioX" exact component={PainelRaioXFinanceiro} />
        <PrivateRoute path="/financeiroParcelaPagar" component={PainelParcelaPagar} />
        <PrivateRoute path="/financeiroParcelaDetalhe/:id" component={DetalheParcelaPagar} />
        <PrivateRoute path="/financeiroPrevisaoDetalhe/:id" component={DetalhePrevisaoPagamento} />
        <PrivateRoute path="/pagamentoCartao/:parcelaId" component={PagamentoCartao} />
        <PrivateRoute path="/pagamentoCartaoOrcamento/:parcelaId" component={PagamentoCartao} />
        <PrivateRoute path="/cadastroParcelaPagar/:id?" component={CadastroParcelaPagar} />

        <PrivateRoute path="/financeiroRelatorioDre" component={RelatorioDre} />

        <PrivateRoute path="/financeiroParcelaReceber" component={PainelParcelaReceber} />
        <PrivateRoute path="/cadastroParcelaReceber/:id?" component={CadastroParcelaReceber} />
        <PrivateRoute path="/financeiroParcelaRelatorio" component={RelatorioFinanceiroParcela} />



        <PrivateRoute path="/financeiroPlanoConta" component={PainelPlanoConta} />
        <PrivateRoute path="/cadastroPlanoConta/:id?" component={CadastroPlanoConta} />

        <PrivateRoute path="/financeiroCaixa" component={PainelCaixa} />
        <PrivateRoute path="/cadastroCaixa/:id?" component={CadastroCaixa} />



        <PrivateRoute path="/eventoChecklistAtividade" component={PainelEventoChecklistAtividade} />
        <PrivateRoute path="/cadastroEventoChecklistAtividade/:id?" component={CadastroEventoChecklistAtividade} />


        <PrivateRoute path="/empresa" component={PainelEmpresa} />
        <PrivateRoute path="/cadastroEmpresa/:id?" component={CadastroEmpresa} />

        {/* Sem `roles`: quem enxerga o painel é quem é destinatário de algum alerta, e isso não
            cabe numa lista de perfis. A própria tela diz "você não tem SLA atribuído" quando o
            endpoint devolve vazio, e o backend escopa os dados de qualquer forma. */}
        <PrivateRoute path="/painelSla" component={PainelSlaDashboard} />
        <PrivateRoute path="/sla" component={PainelSla} roles={['admin', 'diretor']} />
        <PrivateRoute path="/cadastroSla/:id?" component={CadastroSla} roles={['admin', 'diretor']} />
        {/* Só admin: configurar critério é escolher coluna de banco. O diretor consome os
            critérios já existentes pelos selects do cadastro de SLA, que batem em
            /slaCriterio/opcoes — esse sim liberado para ele. */}
        <PrivateRoute path="/slaCriterio" component={PainelSlaCriterio} roles={['admin']} />
        <PrivateRoute path="/cadastroSlaCriterio/:id?" component={CadastroSlaCriterio} roles={['admin']} />

        <PrivateRoute path="/alterarSenha" component={AlterarSenha} />

        {/* Catch-all 404 — mantem o layout (navbar/sidebar). PrivateRoute: nao-logado vai pro login */}
        <PrivateRoute component={NotFound} />

      </Switch>
      </LayoutErrorBoundary>
      </PermissoesProvider>
      </BreadcrumbProvider>
    </BrowserRouter>
  );
}
